import React, { useState, useEffect } from "react";
import { FaLink } from "react-icons/fa6";
import { FaPhoneFlip } from "react-icons/fa6";
import { GrMail } from "react-icons/gr";

const StartupForm = ({ startUpForms, startUpFormsData }) => {

  const type = [
    "Société coopérative",
    "ONG",
    "Faîtière",
    "Association",
    "Autre"
  ];

  const forme = [
    "Groupement d’Intérêt Économique(GIE)",
    "SARL Pluripersonnelle",
    "SA Pluripersonnelle",
    "SNC (Société en Nom Collectif)",
    "SCS (Société en Commandite simple)",
    "SAS (Société par Actions Simplifiée)",
    "Autre (à préciser)",
    "Non applicable(NA)"
  ];

  const fiscal = [
    "RSI (Régime Simplifié d’imposition)",
    "RNI (Régime Normal d’imposition)",
    "Autre",
    "Non Applicable (NA)"
  ];

  const activite = [
    "Agriculture",
    "Agro-industrie",
    "Elevage",
    "Tourisme et Hôtellerie",
    "Artisanat",
    "Commerce",
    "TIC",
    "Transport",
    "Prestation de Services",
    "Banque/Finances/Assurance",
    "BTP",
    "Energie",
    "Cabinet Conseils",
    "Industrie",
    "Education & Formation",
    "Santé",
    "Autre (à préciser)"
  ];

  const reconnaissance = [
    "Internet (Site Web, Réseaux sociaux, etc.)",
    "Au cours d’un évènement (Salon & foire, Forum, Séminaire, Panel, Atelier, etc.)",
    "Médias (Télévision, Radio, Presse écrite, affichage, etc.)",
    "A travers une connaissance",
    "Autre (à préciser)"
  ];

  const [startUpForm, setStartUpForm] = useState({
    denomination: "",
    sector: type[0],
    entreprise_email: activite[0],
    ncc: forme[0],
    nrc: "",
    entreprise_phone: fiscal[0],
    address: "",
    website: "",
    agrement: "",
    reconnaissance: reconnaissance[0],
    ...startUpForms,
  });

  const handleChange = (e) => {
    setStartUpForm({
      ...startUpForm,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    startUpFormsData(startUpForm);
  }, [startUpForm]);

  return (
    <div>
      <form class="row mt-3 g-3">
        <div class="col-md-6">
          <label for="denomination" class="form-label">
            *Nom du groupement
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="denomination"
              name="denomination"
              value={startUpForm.denomination}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div class="col-md-6">
          <label for="secteurActivite" class="form-label">
            *Type de groupement
          </label>
            {/* <input
              type="text"
              class="form-control border-0"
              id="secteurActivite"
              name="sector"
              value={startUpForm.sector}
              onChange={handleChange}
              required
            /> */}
            <select
              class="form-select form-select-lg mb-3 form-input-droit"
              aria-label="Large select example"
              name="sector"
              value={startUpForm.sector}
              onChange={handleChange}
            >
              {type && type.map((item) => <option value={item}>{item}</option>)}
            </select>
        </div>
        <div class="col-md-6">
          <label for="numeroRC" class="form-label">
          *Objet social
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <input
              type="text"
              class="form-control border-0"
              id="numeroRC"
              name="nrc"
              value={startUpForm.nrc}
              onChange={handleChange}
            />
          </div>
        </div>
        <div class="col-md-6">
          <label for="numeroCC" class="form-label">
          *Forme juridique
          </label>
            {/* <input
              type="text"
              class="form-control border-0"
              id="numeroCC"
              name="ncc"
              value={startUpForm.ncc}
              onChange={handleChange}
            /> */}
            <select
              class="form-select form-select-lg mb-3 form-input-droit"
              aria-label="Large select example"
              name="ncc"
              value={startUpForm.ncc}
              onChange={handleChange}
            >
              {forme && forme.map((item) => <option value={item}>{item}</option>)}
            </select>
        </div>

        <div class="col-md-6">
          <label for="telephone" class="form-label">
          *Régime fiscal
          </label>
            {/* <FaPhoneFlip />
            <input
              type="text"
              class="form-control border-0 "
              id="telephone"
              placeholder="+2250555475465"
              name="entreprise_phone"
              value={startUpForm.entreprise_phone}
              onChange={handleChange}
              required
            /> */}
            <select
              class="form-select form-select-lg mb-3 form-input-droit"
              aria-label="Large select example"
              name="entreprise_phone"
              value={startUpForm.entreprise_phone}
              onChange={handleChange}
            >
              {fiscal && fiscal.map((item) => <option value={item}>{item}</option>)}
            </select>
        </div>

        <div class="col-md-6">
          <label for="email" class="form-label">
          Secteur d’activité
          </label>
            {/* <GrMail />
            <input
              type="email"
              class="form-control border-0"
              id="email"
              name="entreprise_email"
              onChange={handleChange}
              value={startUpForm.entreprise_email}
              required
            /> */}
            <select
              class="form-select form-select-lg mb-3 form-input-droit"
              aria-label="Large select example"
              name="entreprise_email"
              value={startUpForm.entreprise_email}
              onChange={handleChange}
            >
              {activite && activite.map((item) => <option value={item}>{item}</option>)}
            </select>
        </div>

        <div class="col-md-3">
          <label for="adresse" class="form-label">
          *Nombre de membre
          </label>
          <div>
            <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
              <input
                type="text"
                class="form-control border-0"
                id="adresse"
                name="address"
                value={startUpForm.address}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        {/* <div class="col-md-6">
          <label for="siteWeb" class="form-label">
            *Site web
          </label>
          <div className="d-flex py-1 px-2  justify-content-center bg-white align-items-center border rounded">
            <FaLink />
            <input
              type="text"
              class="form-control border-0"
              id="siteWeb"
              name="website"
              onChange={handleChange}
              value={startUpForm.website}
            />
          </div>
        </div> */}

        <div className="col-md-4">
          <p>Avez-vous un agrément ?</p>
          <div className="d-flex gap-5">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="website"
                value="true"
                onChange={handleChange}
                id="nonDiaspora"
                checked={startUpForm.website == "true" ? true : false}
              />
              <label class="form-check-label" for="nonDiaspora">
                Oui
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="website"
                value="false"
                onChange={handleChange}
                id="ouiDiaspora"
                checked={startUpForm.website == "false" ? true : false}
              />
              <label class="form-check-label" for="ouiDiaspora">
                Non
              </label>
            </div>
          </div>
        </div>

        <div className="col-md-5">
          <p>Avez-vous un récépissé de dépôt de demande d'agrément?</p>
          <div className="d-flex gap-5">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="agrement"
                value="true"
                onChange={handleChange}
                id="nonagrement"
                checked={startUpForm.agrement== "true" ? true : false}
              />
              <label class="form-check-label" for="nonagrement ">
                Oui
              </label>
            </div>

            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                name="agrement"
                value="false"
                onChange={handleChange}
                id="ouiagrement"
                checked={startUpForm.agrement == "false" ? true : false}
              />
              <label class="form-check-label" for="ouiagrement">
                Non
              </label>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <label for="email" class="form-label">
          *Comment avez-vous connu le GUDE?
          </label>
            {/* <GrMail />
            <input
              type="email"
              class="form-control border-0"
              id="email"
              name="entreprise_email"
              onChange={handleChange}
              value={startUpForm.entreprise_email}
              required
            /> */}
            <select
              class="form-select form-select-lg mb-3 form-input-droit"
              aria-label="Large select example"
              name="reconnaissance"
              value={startUpForm.reconnaissance}
              onChange={handleChange}
            >
              {reconnaissance && reconnaissance.map((item) => <option value={item}>{item}</option>)}
            </select>
        </div>

      </form>
    </div>
  );
};

export default StartupForm;
